import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import About from './components/About';
import Contact from './components/Contact';
import GalleryPage from './components/GalleryPage';
import NotFound from './components/NotFound';
import Footer from './components/Footer';
import './App.css';

// Image data — re-run `npm run generate-images` after adding photos to public/images/
import portraitsData from './data/portraits.json';
import musicData from './data/music.json';
import africaData from './data/africa.json';
import newyorkData from './data/newyork.json';
import weddingData from './data/wedding.json';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Navigation />

        <div className="content-area">
          <Routes>
            <Route
              path="/"
              element={
                <GalleryPage
                  title="PEOPLE"
                  data={portraitsData}
                  seoDescription="Portrait photography by Erik Hoffman, Baltimore-based photographer."
                />
              }
            />
            <Route
              path="/portraits"
              element={
                <GalleryPage
                  title="PEOPLE"
                  data={portraitsData}
                  seoDescription="Portrait photography by Erik Hoffman, Baltimore-based photographer."
                />
              }
            />
            <Route
              path="/music"
              element={
                <GalleryPage
                  title="MUSIC"
                  data={musicData}
                  seoDescription="Music and concert photography by Erik Hoffman."
                />
              }
            />
            <Route
              path="/weddings"
              element={
                <GalleryPage
                  title="WEDDINGS"
                  data={weddingData}
                  seoDescription="Wedding photography by Erik Hoffman, capturing every moment of your special day."
                />
              }
            />
            <Route
              path="/africa"
              element={
                <GalleryPage
                  title="AFRICA"
                  data={africaData}
                  seoDescription="Travel photography from Africa by Erik Hoffman."
                />
              }
            />
            <Route
              path="/newyork"
              element={
                <GalleryPage
                  title="NEW YORK"
                  data={newyorkData}
                  seoDescription="New York City photography by Erik Hoffman."
                />
              }
            />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>

          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
